/*
 * Currency Object Polyfill
 * Provides a dummy Currency object to prevent errors
 */

if (typeof Currency === 'undefined') {
  window.Currency = {
    convertAll: function(from, to, selector, format) {
      // Do nothing - prices will display in shop's default currency
      console.log('Currency conversion disabled - using default currency');
    },
    currentCurrency: '',
    format: 'money_format',
    moneyFormats: {},
    cookie: {
      read: function() { return ''; },
      write: function() {}
    }
  };
}
